<template>
  <div class="common-layout">
    <el-container>
      <el-affix :offset="0" position="top" style="width: 100% !important">
        <el-header>
          <HeaderComponent v-if="userAuthenticated" />
        </el-header>
      </el-affix>
      <el-row class="envClass" v-if="envName !== ''"
        >Environment : {{ envName }}
      </el-row>
      <el-main>
        <ErrorMessage v-if="userError" />
        <TimeoutErrorComponent v-if="requestErrors" />
        <div
          typeof="primary"
          v-loading.fullscreen.lock="fetchingUserInfo"
        ></div>
        <router-view
          v-if="
            userAuthenticated &&
            !userError &&
            !requestErrors &&
            !fetchingUserInfo
          "
        />
      </el-main>
    </el-container>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { mapGetters } from "vuex";
import { AuthActionTypes } from "@/store/authstore/AuthActionTypes";
import { useIsAuthenticated } from "@/composition-api/useIsAuthenticated";
import _ from "lodash";
import TimeoutErrorComponent from "./components/TimeoutErrorComponent.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    HeaderComponent,
    ErrorMessage,
    TimeoutErrorComponent,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "getErrorOccured",
      "getCurrentUser",
      "getUserError",
      "getfetchingCurrentUser",
    ]),
    envName(): string {
      return !_.isEmpty(this.getCurrentUser) &&
        this.getCurrentUser.result.environmentName !== ""
        ? this.getCurrentUser.result.environmentName
        : "";
    },
    userAuthenticated(): boolean {
      return useIsAuthenticated().value;
    },
    userError(): any {
      return this.getUserError;
    },
    requestErrors(): boolean {
      return this.getErrorOccured;
    },
    fetchingUserInfo(): boolean {
      return this.getfetchingCurrentUser;
    },
  },
  methods: {
    processLogin() {
      this.$store.dispatch(AuthActionTypes.LOGIN);
      if (this.$route.name === "home" || this.$route.name === "auth")
        this.$router.push("/account");
    },
  },
  created() {
    if (useIsAuthenticated().value) {
      this.processLogin();
    }
  },
});
</script>

<style lang="scss">
#app {
  font-family: "Open Sans", sans-serif, Avenir, Helvetica, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #101010;
  background: #efefef;
}

body {
  margin: 0;
  color: #101010;
  border: 1px solid #d6d8da;
  height: 100vh;
  background-color: #efefef;
  font-family: "Open Sans", sans-serif;
}
</style>
